import { Customer } from "@jugl-web/rest-api/customer";
import { customerPhoneStringToDisplay } from "./utils/customerPhoneStringToDisplay";

export const getCustomerFirstName = (customer: Customer) =>
  customer.fields.find(
    (item) =>
      item.field.section === "personal" && item.field.name === "first_name"
  )?.value || "";

const getCustomerLastName = (customer: Customer) =>
  customer.fields.find(
    (item) =>
      item.field.section === "personal" && item.field.name === "last_name"
  )?.value || "";

export const getCustomerEmail = (customer: Customer) =>
  customer.fields.find(
    (item) => item.field.section === "personal" && item.field.name === "email"
  )?.value || "";

export const getCustomerPhone = (customer: Customer) =>
  customer.fields.find(
    (item) =>
      item.field.section === "personal" && item.field.name === "phone_number"
  )?.value || "";

const getCustomerContact = (customer: Customer) => {
  const email = getCustomerEmail(customer);
  const phone = getCustomerPhone(customer);

  if (phone) {
    return customerPhoneStringToDisplay(phone);
  }

  return email || "";
};

export const getCustomerFullName = (customer: Customer) => {
  const firstName = getCustomerFirstName(customer);
  const lastName = getCustomerLastName(customer);

  return [firstName, lastName].filter((item) => !!item).join(" ");
};

export interface CustomerDetails {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  avatarUrl: string | null;
  companyName?: string;
  position?: string;
  contact: string;
}

export const getCustomerDetails = (customer: Customer): CustomerDetails => ({
  id: customer.id,
  firstName: getCustomerFirstName(customer),
  lastName: getCustomerLastName(customer),
  fullName: getCustomerFullName(customer),
  avatarUrl: customer.logo,
  position:
    customer.fields.find((c) => c.field.name === "position")?.value ||
    undefined,
  companyName:
    customer.fields.find((c) => c.field.name === "company_name")?.value ||
    undefined,
  contact: getCustomerContact(customer),
});
